import { TextField, Button } from "@mui/material";
import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import unipetroLogo from "../../images/Grupo Logo Unipetro pequeno.jpg";
import { Context } from "../../context/context";
import { loginData } from "../../services/login-service";
import PasswordLostModal from "../../components/Modal/PasswordLost/PasswordLostModal";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [open, setOpen] = useState(false);
  const { setUserData } = useContext(Context);

  const navigate = useNavigate();
  async function handleSubmit(e) {
    e.preventDefault();

    const data = { email, password };

    const result = await loginData(data);

    setUserData(result.data.user);
    if (result.name === "AxiosError") return;

    navigate("/simulador");
  }

  useEffect(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("user");
    localStorage.removeItem("userName");
  }, []);

  return (
    <div className="login-wrapper">
      {open && <PasswordLostModal open={open} setOpen={setOpen} />}
      <div className="login-wrapper__container">
        <img src={unipetroLogo} alt="logo" />
        <form onSubmit={handleSubmit}>
          <TextField label="Email" onChange={(e) => setEmail(e.target.value)} />
          <TextField
            label="Senha"
            onChange={(e) => setPassword(e.target.value)}
            type="password"
          />
          <div className="btns-container-login">
            <Button type="submit" variant="contained">
              Entrar
            </Button>
            <Button onClick={() => setOpen(true)} variant="outlined">
              Esqueceu sua senha?
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
